import Api from '../api';
import {ADD_MY_SENDER_ID_URL, FIRST_RUN_CHOICE_URL, GET_SMS_CONFIG_URL, MY_ONBOARDING_URL} from '../lib/constant';
import {CHOICE_DLT_READY} from '../lib/firstRun';

// Plain promise calls (no store): the first-run gate owns its own state.

export const fetchMyOnboarding = () => Api.get(MY_ONBOARDING_URL).then(({data}) => data);

export const chooseNoDlt = (choice) => Api.post(FIRST_RUN_CHOICE_URL, {choice}).then(({data}) => data);

// submitExistingDlt applies the org's own DLT setup: the choice (backend
// applies the PE ID), then the headers it does not have yet. Templates are
// added later from Templates/Headers. Stops at the first failure; re-running
// it is safe.
export const submitExistingDlt = async ({peId, senderIds}) => {
  await Api.post(FIRST_RUN_CHOICE_URL, {
    choice: CHOICE_DLT_READY,
    dltPrincipalEntityId: peId.trim(),
    senderIds
  });

  const {data: config} = await Api.get(GET_SMS_CONFIG_URL);
  const existing = ((config && config.data && config.data.senderIds) || []).map((s) => String(s.senderId || '').toUpperCase());
  const missing = senderIds.filter((id) => !existing.includes(id));
  if (missing.length > 0) {
    await Api.post(ADD_MY_SENDER_ID_URL, {senderIds: missing});
  }
};

// reloadApp starts the app over once setup is done: the Send SMS, Customize
// SMS and Dashboard views keep the sms_config they read on mount, which had
// no headers yet.
export const reloadApp = () => window.location.reload();
